export default "__VITE_ASSET__BbFBnU75__"